import api from './api';

const giftService = {
  // Get available gift types
  getAvailableGifts: () => api.get('/gifts/available'),
  
  // Send gift
  sendGift: (receiverId, giftType, message = '', isAnonymous = false, asUserId = null) => 
    api.post('/gifts/send', { 
      receiver_id: receiverId, 
      gift_type: giftType, 
      message, 
      is_anonymous: isAnonymous,
      ...(asUserId && { as_user_id: asUserId })
    }),

  
  // Get received gifts
  getReceivedGifts: (unopenedOnly = false) => 
    api.get('/gifts/received', { params: { unopened_only: unopenedOnly } }),
  
  // Get sent gifts
  getSentGifts: () => api.get('/gifts/sent'),
  
  // Open a gift
  openGift: (giftId) => api.post(`/gifts/${giftId}/open`),
  
  // Get gift statistics
  getStatistics: () => api.get('/gifts/statistics'),
};

export default giftService;
